import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

const duplicate = async (boardId, payload) => {
  const user = firebase.auth().currentUser
  if (!user) return null
  const userAuthToken = await user.getIdToken()

  const { data: response } = await AxiosConfig.post(`/boards/duplicate/${boardId}`, payload, {
    headers: {
      Authorization: `Bearer ${userAuthToken}`
    }
  })
  return response.data
}

// id can either be direct board_id or shared board id (board_id is only supported for legacy links)
const getPublicBoard = async (id) => {
  try {
    const user = firebase.auth()?.currentUser
    const userAuthToken = user ? await user.getIdToken() : null

    // Always send Authorization header, even if token is null
    const { data } = await AxiosConfig.get(`/boards/public/${id}`, {
      headers: {
        Authorization: userAuthToken ? `Bearer ${userAuthToken}` : null
      }
    })
    return data
  } catch (error) {
    const payload = error.response?.data
    return {
      error: true,
      data: payload?.data ?? null,
      message: payload?.message || 'Unable to load this board',
      status: error.response?.status || 500
    }
  }
}

export default {
  getPublicBoard,
  duplicate
}
